import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-edit-tool-paint-roller.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M232 88h-16V64a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v24H16a8 8 0 0 0 0 16h16v24a16 16 0 0 0 16 16h152a16 16 0 0 0 16-16v-24h16v50l-100.4 28.65A16.07 16.07 0 0 0 120 198v34a8 8 0 0 0 16 0v-34l100.4-28.68A16.07 16.07 0 0 0 248 154v-50a16 16 0 0 0-16-16m-32 40H48V64h152z" }, null, -1)])]);
}
var interface_edit_tool_paint_roller_default = { render };
//#endregion
export { interface_edit_tool_paint_roller_default as default, render };

//# sourceMappingURL=interface-edit-tool-paint-roller.svg.js.map